"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeLaunchDarkly = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _featureFlags = require("./featureFlags");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @description This is a temporary function that will be used to initialize LaunchDarkly
 * @param {Object} ldPayload
 * @param {Object} ldPayload.user
 * @param {Object} ldPayload.team
 * @param {Object} ldPayload.event
 * @param {Object} ldPayload.broadcast
 * @param key
 */
var initializeLaunchDarkly = exports.initializeLaunchDarkly = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref, key) {
    var user, team, event, broadcast, url, payload;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          user = _ref.user, team = _ref.team, event = _ref.event, broadcast = _ref.broadcast;
          url = window.location.href;
          payload = {
            user: _objectSpread(_objectSpread({}, user), {}, {
              url: url
            }),
            team: team,
            event: event,
            broadcast: broadcast
          };
          _context.prev = 3;
          _context.next = 6;
          return (0, _featureFlags.initFeatureFlags)(payload, key);
        case 6:
          console.log('LaunchDarkly initialized successfully.');
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](3);
          console.warn('Failed to load feature flag settings.');
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 9]]);
  }));
  return function initializeLaunchDarkly(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();